import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function Blogs() {
    return (

        <div className="inner-page">

            <Header />


            <div className="rts-breadcrumb-area bg_image">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="baread-crumb-main-wrapper pt--100">
                                <div className="inner">
                                    <h1 className="title rts_hero__title">Blogs</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="blog-list-area pb--120 pt--80">
                <div className="container-150  rts-section-gap">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="single-blog-list-one rts-skew-up-gsap">
                                <a href="blog-details.html" className="thumbnail">
                                    <img src="assets/images/blog/11.jpg" alt="blog_images" />
                                </a>
                                <div className="blog-content-area">
                                    <span>Photography / Module Design</span>
                                    <a href="blog-details.html">
                                        <h3 className="title quote">Awesome Photography Module Design <br />
                                            Interactive Journey</h3>
                                    </a>
                                    <p className="disc">
                                        If you want to have an effective content with the latest trends. When you think of creating <br /> content most people’s minds go straight to blogging.
                                    </p>
                                    <a href="blog-details.html" className="read-more-bb">Read More</a>
                                </div>
                            </div>
                            <div className="single-blog-list-one rts-skew-up-gsap">
                                <a href="blog-details.html" className="thumbnail">
                                    <img src="assets/images/blog/12.jpg" alt="blog_images" />
                                </a>
                                <div className="blog-content-area">
                                    <span>Photography / Module Design</span>
                                    <a href="blog-details.html">
                                        <h3 className="title quote">Awesome Photography Module Design <br />
                                            Interactive Journey</h3>
                                    </a>
                                    <p className="disc">
                                        If you want to have an effective content with the latest trends. When you think of creating <br /> content most people’s minds go straight to blogging.
                                    </p>
                                    <a href="blog-details.html" className="read-more-bb">Read More</a>
                                </div>
                            </div>
                            <div className="single-blog-list-one rts-skew-up-gsap">
                                <a href="blog-details.html" className="thumbnail">
                                    <img src="assets/images/blog/13.jpg" alt="blog_images" />
                                </a>
                                <div className="blog-content-area">
                                    <span>Photography / Module Design</span>
                                    <a href="blog-details.html">
                                        <h3 className="title quote">Awesome Photography Module Design <br />
                                            Interactive Journey</h3>
                                    </a>
                                    <p className="disc">
                                        If you want to have an effective content with the latest trends. When you think of creating <br /> content most people’s minds go straight to blogging.
                                    </p>
                                    <a href="blog-details.html" className="read-more-bb">Read More</a>
                                </div>
                            </div>
                            <div className="single-blog-list-one rts-skew-up-gsap">
                                <a href="blog-details.html" className="thumbnail">
                                    <img src="assets/images/blog/14.jpg" alt="blog_images" />
                                </a>
                                <div className="blog-content-area">
                                    <span>Photography / Module Design</span>
                                    <a href="blog-details.html">
                                        <h3 className="title quote">Awesome Photography Module Design <br />
                                            Interactive Journey</h3>
                                    </a>
                                    <p className="disc">
                                        If you want to have an effective content with the latest trends. When you think of creating <br /> content most people’s minds go straight to blogging.
                                    </p>
                                    <a href="blog-details.html" className="read-more-bb">Read More</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <Footer />


            <div className="loading-screen" id="loading-screen">
                <span className="bar top-bar"></span>
                <span className="bar down-bar"></span>
                <span className="progress-line"></span>
                <span className="loading-counter"> </span>
            </div>


            <div className="bg-noise"></div>



            <div className="progress-wrap">
                <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
                    <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"></path>
                </svg>
            </div>

            <div className="rts-cursor cursor-outer" data-default="yes" data-link="yes" data-slider="no">
                <span className="fn-cursor"></span>
            </div>
            <div className="rts-cursor cursor-inner" data-default="yes" data-link="yes" data-slider="no">
                <span className="fn-cursor">
                    <span className="fn-left"></span>
                    <span className="fn-right"></span>
                </span>
            </div>

            <div className="modal-sidebar-scroll rts-dark-light">
                <ul>
                    <li className="go-dark-w"><span>Dark</span><i className="rts-go-dark fal fa-moon"></i></li>
                    <li className="go-light-w"><span>Light</span><i className="rts-go-light fa-light fa-brightness"></i></li>
                </ul>
            </div>


        </div>
    )
}

export default Blogs
